export default {
    path: '/', component: () => import("@/pages/Cabinet/Master/App"),
    children: [
        {
            path: '/cabinet', name: 'master.cabinet', redirect: {name: 'master.cabinet.settings'},
        },
        {
            path: '/cabinet/master/clients',
            name: 'master.cabinet.clients',
            component: () => import("@/pages/Cabinet/Master/Clients/Index"),
        },
        {
            path: '/cabinet/master/calendar/:calendar',
            name: 'master.cabinet.calendar',
            component: () => import("@/pages/Cabinet/Master/Calendar"),
        },
        {
            path: '/cabinet/master/packages',
            name: 'master.cabinet.packages',
            component: () => import("@/pages/Cabinet/Master/Tariff/Index"),
        },
        {
            path: '/cabinet/master/analytics',
            name: 'master.cabinet.analytics',
            component: () => import("@/pages/Cabinet/Master/Analytics/Index"),
        },
        {
            path: '/cabinet/master/portfolio',
            name: 'master.cabinet.portfolio',
            component: () => import("@/pages/Cabinet/Master/Portfolio"),
        },
        {
            path: '/cabinet/master/bonus',
            name: 'master.cabinet.bonus',
            component: () => import("@/pages/Cabinet/Master/Bonus"),
        },
        {
            path: '/cabinet/master/messages',
            name: 'master.cabinet.messages',
            component: () => import("@/pages/Cabinet/Master/Chat"),
        },
        {
            path: '/cabinet/master/notifications',
            name: 'master.cabinet.notifications',
            component: () => import("@/pages/Cabinet/Master/Notifications"),
        },
        {
            path: '/cabinet/master/settings',
            name: 'master.cabinet.settings',
            component: () => import("@/pages/Cabinet/Master/Settings/Index"),
        },
        {
            path: '/cabinet/master/instruction',
            name: 'master.cabinet.instruction',
            component: () => import("@/pages/Cabinet/Master/QnA/QnA"),
        },
    ]
};